import { Spinner } from 'react-bootstrap';

export default function InitAuthentication() {
    return (
        <div className='text-center flex-grow-1 mt-2'>
            <p>Authenticating</p>
            <Spinner
                animation='border'
                role='status'
            />
        </div>
    );
}
